/* global axios */
import ApiClient from '../ApiClient';

// Estado/vinculación de un inbox de WhatsApp por QR (admin-only). Backend: Api::V1::Accounts::Masifi::WhatsappQrController.
class MasifiWhatsappQrAPI extends ApiClient {
  constructor() {
    super('masifi/whatsapp_qr', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}`);
  }

  // Fase 2 (spec §3.1): `pairing: 'code'` vincula con el número del inbox (código); sin él, QR como siempre.
  connect(inboxId, { riskAccepted = false, pairing = 'qr' } = {}) {
    return axios.post(`${this.url}/${inboxId}/connect`, {
      risk_accepted: riskAccepted,
      ...(pairing === 'code' ? { pairing } : {}),
    });
  }

  pause(inboxId) {
    return axios.post(`${this.url}/${inboxId}/pause`);
  }

  unlink(inboxId) {
    return axios.post(`${this.url}/${inboxId}/unlink`);
  }

  // Ajustes por número (spec polish-1 §4): las claves de NumberSettings tal cual (snake_case, fuente única YAML); el
  // backend valida tipo y valor y hace merge atómico en provider_config.
  updateSettings(inboxId, settings = {}) {
    return axios.patch(`${this.url}/${inboxId}/settings`, settings);
  }
}

// Estado grueso del número para los agentes del inbox (F2 ruling 15). Backend: WhatsappQrStatusController.
// Instancia de ApiClient (no una 2ª clase: max-classes-per-file) con `get(inboxId)` = show.
export const masifiWhatsappQrStatusAPI = Object.assign(
  new ApiClient('masifi/whatsapp_qr_status', { accountScoped: true }),
  {
    get(inboxId) {
      return axios.get(`${this.url}/${inboxId}`);
    },
  }
);

export default new MasifiWhatsappQrAPI();
